import { StandaloneSavedArticles } from 'base/components/SavedArticles';

export const AllasStandaloneSavedArticles: typeof StandaloneSavedArticles = (props) => {
  return <StandaloneSavedArticles headline="Dina sparade artiklar" {...props} />;
};
